import packageJson from '#main/package.json'

export const CURRENT_VERSION = packageJson.version
export const VERSION_KEY = `__${packageJson.version}v`

export type StorageArea = 'local' | 'session'
export type CleanupReason = 'expired' | 'version_mismatch'
export type StorageCleanupObserver = (key: string, area: StorageArea, reason: CleanupReason) => void

const storageCleanupObservers: StorageCleanupObserver[] = []

export function addStorageCleanupObserver(observer: StorageCleanupObserver): void {
  storageCleanupObservers.push(observer)
}

export function removeStorageCleanupObserver(observer: StorageCleanupObserver): void {
  const index = storageCleanupObservers.indexOf(observer)
  if (index > -1) {
    storageCleanupObservers.splice(index, 1)
  }
}

export function notifyStorageCleanup(key: string, area: StorageArea, reason: CleanupReason): void {
  storageCleanupObservers.forEach((observer) => observer(key, area, reason))
}

export function applyVersionCompatibility(): void {
  const storedVersion = localStorage.getItem(VERSION_KEY)

  if (storedVersion && storedVersion !== CURRENT_VERSION) {
    const localKeysToRemove: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key && key !== VERSION_KEY) {
        localKeysToRemove.push(key)
      }
    }

    const sessionKeysToRemove: string[] = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i)
      if (key) {
        sessionKeysToRemove.push(key)
      }
    }

    localKeysToRemove.forEach((key) => {
      localStorage.removeItem(key)
      notifyStorageCleanup(key, 'local', 'version_mismatch')
    })

    sessionKeysToRemove.forEach((key) => {
      try {
        sessionStorage.removeItem(key)
        notifyStorageCleanup(key, 'session', 'version_mismatch')
      } catch {
        // ignore
      }
    })
  }

  localStorage.setItem(VERSION_KEY, CURRENT_VERSION)
}

applyVersionCompatibility()
